import { render, staticRenderFns } from "./BtnAtivarDesativarSubItemContrato.vue?vue&type=template&id=9344ab0c&"
import script from "./BtnAtivarDesativarSubItemContrato.vue?vue&type=script&lang=js&"
export * from "./BtnAtivarDesativarSubItemContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports